<template>
  <div
    style="cursor:pointer"
    @click="statClicked"
    v-bind:class="selected ? 'selected' : ''"
  >
    <b-row class="m-0">
      <b-col class="p-0">
        <slot>
          <div class="data-head text-muted">
            <i
              v-if="icon"
              :style="'color:' + iconColor"
              :class="icon"
            ></i>{{ title }}
          </div>
          <div class="data-data" v-if="subTitle != null">
            {{subTitle}}<i class="fa-light fa-chart-mixed showchart"></i>
          </div>
        </slot>
      </b-col>
    </b-row>
    <b-row class="m-0 data-sub">
      <b-col class="p-0">
        <slot name="footer"></slot>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats",
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    icon: String,
    iconColor: String,
    link: String,
    title: String,
    subTitle: String,
    selected: Boolean,
    iconClasses: [String, Array],
  },
  methods: {
    statClicked() {
      this.$emit("clicked", this.selected);
    },
  },
};
</script>
